import React, { FC } from 'react';
import styles from './styles.module.css';

type NoResultsProps = {
  isVisible?: boolean;
  children?: React.ReactNode;
};

export const NoResults: FC<NoResultsProps> = ({ isVisible, children }) =>
  isVisible ? <div className={styles.noResults}>{children}</div> : null;
